export default __webpack_public_path__ + "media/images/icons/comments-dollar-solid-697e26da800308bf806cd1b695ee8af2.svg";